import { AlertCircle, Inbox } from 'lucide-react';
import Button from './Button';

export const LoadingState = ({ rows = 4 }) => (
  <div className="space-y-3">
    {Array.from({ length: rows }).map((_, index) => (
      <div key={index} className="h-14 animate-pulse rounded-md bg-gray-100" />
    ))}
  </div>
);

export const EmptyState = ({ title = 'Sin datos', message, actionLabel, onAction }) => (
  <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white px-6 py-12 text-center">
    <Inbox className="h-10 w-10 text-gray-400" />
    <h3 className="mt-3 text-base font-semibold text-gray-900">{title}</h3>
    {message && <p className="mt-1 max-w-md text-sm text-gray-600">{message}</p>}
    {actionLabel && onAction && (
      <Button type="button" className="mt-4" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-800">
    <div className="flex items-start gap-3">
      <AlertCircle className="mt-0.5 h-5 w-5" />
      <div className="flex-1">
        <p className="font-semibold">No se pudo cargar la informacion</p>
        <p className="mt-1 text-sm">{message}</p>
        {onRetry && (
          <Button type="button" variant="secondary" size="sm" className="mt-3" onClick={onRetry}>
            Reintentar
          </Button>
        )}
      </div>
    </div>
  </div>
);
